import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-12 h-12 rounded-full mx-auto bg-red-600 bg-opacity-10 flex justify-center items-center flex-shrink-0" }
const _hoisted_2 = { class: "text-sm leading-5 text-gray-500" }
const _hoisted_3 = {
  key: 0,
  class: "mt-6 flex space-x-2 justify-between"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-6 flex space-x-2 justify-end"
}

import {
  DialogTitle,
} from '@headlessui/vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteConfirmationModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'w-[480px] p-6'
    },
    typeTwo: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(__props.typeTwo ? 'text-center mb-5' : 'flex space-x-4 mb-5')
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(QuestionMarkCircleIcon), { class: "w-6 h-6 text-red-600 mx-auto" })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full", __props.typeTwo ? 'mt-6' : 'text-left'])
        }, [
          _createVNode(_unref(DialogTitle), {
            as: "p",
            class: "font-bold text-lg text-neutral-900",
            tabindex: "0"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_2, _toDisplayString(__props.content), 1)
        ], 2)
      ], 2),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "fields")
      ]),
      (__props.typeTwo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (__props.cancelText)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  size: "large",
                  btnWidth: "quinary rounded-lg w-full",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.cancelText), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.actionText)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 1,
                  size: "large",
                  btnWidth: "red rounded-lg w-full",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.actionText), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (__props.cancelText)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  size: "large",
                  btnWidth: "quinary rounded-lg",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.cancelText), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.actionText)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 1,
                  size: "large",
                  btnWidth: "red rounded-lg",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('confirm')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.actionText), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 3
  }, 8, ["customClass", "show"]))
}
}

})